import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  OutlinedInput,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  BUGS_OPT,
  BUG_FLOW_STATIC,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_BUG_REPORT,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  ICategory,
  IProductParams,
} from "../../../model";
import CategoryList from "./categoryList";
import IconUpload from "./iconUpload";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpIcon from "@mui/icons-material/Help";
import { UserLoginInfo } from "../../../types/context";
import { UserContext } from "../../../context/userContext";
import PreviewIcon from "@mui/icons-material/Preview";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { appLogger } from "../../../utils";
// import RichTextEditor from "react-rte";
import Editor from "../../../utils/common/Editor";

import { cloneDeep } from "lodash";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function BugSettings(props: any) {
  appLogger.info({
    infoObj: {
      method: "BugSettings",
      component: "add-product",
      fileName: "bugSettings.tsx",
      props: props,
    },
  });
  const {
    productParams,
    setProductParams,
    errMsg,
    setErrMsg,
    setScroll,
    setpreviewScroll,
    sethandleClick,
    bugSettingsMandatoryCheck,
  } = props;
  const {
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    BugSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;
  const [isJiraSeverity, setIsJiraSeverity] = useState(false);
  // const [richtextval, setrichtextval] = useState(
  //   RichTextEditor.createEmptyValue()
  // );

  const bugFlowType =
    productParams &&
    productParams.products &&
    productParams.products[0] &&
    productParams.products[0].feedbackAgentSettings &&
    productParams.products[0].feedbackAgentSettings.bugSettings &&
    productParams.products[0].feedbackAgentSettings.bugSettings.type
      ? productParams.products[0].feedbackAgentSettings.bugSettings.type
      : BUG_FLOW_STATIC;

  const handleBugTitleChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.title =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugTooltipChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.tooltip =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugDialogMsgChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.dialogMsg =
          event.target.value;
        setProductParams(temp);
        // setrichtextval(
        //   RichTextEditor.createValueFromString(event.target.value, "html")
        // );
      }
    }
  };

  const handleBugCategoryHeadingChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.categoryHeading =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugStdFeedbackHeadingChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.stdFeedbackHeading =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugSeverityHeadingChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.severityHeading =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugGeneralCommentsHeadingChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.generalCommentsHeading =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugAttachmentHelpChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.attachmentHelp =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleBugThanksMsgChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.thanksMsg =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleReqComments = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.reqComments =
          !temp.products[0].feedbackAgentSettings.bugSettings.reqComments;
      }
      setProductParams(temp);
    }
  };

  const handleReqDisplayEmail = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.reqDisplayEmail =
          !temp.products[0].feedbackAgentSettings.bugSettings.reqDisplayEmail;
      }
      setProductParams(temp);
    }
  };

  const handleShowSeverityOption = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.showSeverity =
          !temp.products[0].feedbackAgentSettings.bugSettings.showSeverity;
        if (errMsg && errMsg.bugSeverityErr) {
          const msg = { ...errMsg };
          msg.bugSeverityErr = null;
          setErrMsg(msg);
        }
        setProductParams(temp);
      }
    }
  };

  const handleChangeBugSeverityName = (event: any, sevIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings.severities
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.severities[
          sevIndex
        ] = event.target.value;
        setProductParams(temp);
      }
    }
  };

  const addBugSeverity = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.bugSettings.severities) {
          temp.products[0].feedbackAgentSettings.bugSettings.severities = [];
        }
        temp.products[0].feedbackAgentSettings.bugSettings.severities.push("");
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const deleteBugSeverity = (sevIndex: number) => {
    //    if(!useTrackingSystemSeverity){
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings.severities
      ) {
        const severityValue =
          temp.products[0].feedbackAgentSettings.bugSettings.severities[
            sevIndex
          ];
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].trackingSystem &&
          temp.products[0].trackingSystem.configs &&
          temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS] &&
          temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS].filters &&
          temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS].filters
            .severities &&
          temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS].filters
            .severities[severityValue]
        ) {
          delete temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
            .filters.severities.severityValue;
        }
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].emailConfig &&
          temp.products[0].emailConfig.severityLimit
        ) {
          delete temp.products[0].emailConfig.severityLimit.severityValue;
        }
        temp.products[0].feedbackAgentSettings.bugSettings.severities.splice(
          sevIndex,
          1
        );
        setProductParams(temp);
      }
    }
    //    }
  };

  const addBugCategory = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.categories.push({
          name: "",
          feedbacks: [],
        });
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].trackingSystem
    ) {
      if (
        productParams.products[0].trackingSystem &&
        productParams.products[0].trackingSystem.feedbackTypes &&
        productParams.products[0].trackingSystem.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        if (
          productParams.products[0].trackingSystem &&
          productParams.products[0].trackingSystem.configs &&
          productParams.products[0].trackingSystem.configs[
            FEEDBACK_TYPE_BUGS
          ] &&
          productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
            .severity
        ) {
          setIsJiraSeverity(true);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "bugSettings.tsx",
              },
            },
            "Jira severity enable"
          );
        } else {
          setIsJiraSeverity(false);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "bugSettings.tsx",
              },
            },
            "Jira severity disable"
          );
        }
      }
    }
  }, [productParams]);

  const handleReqCategory = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.reqCategory =
          !temp.products[0].feedbackAgentSettings.bugSettings.reqCategory;
        if (errMsg && errMsg.bugCategoryErr) {
          const msg = { ...errMsg };
          msg.bugCategoryErr = null;
          setErrMsg(msg);
        }
      }
      setProductParams(temp);
    }
  };

  const clearErrMsg = (errMsg: any) => {
    if (
      errMsg.bugSettingErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings.bugSettings
    ) {
      const msg = { ...errMsg };
      msg.bugSettingErr = null;
      setErrMsg(msg);
    }

    if (
      errMsg.bugSeverityErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.bugSettings
        .showSeverity &&
      productParams.products[0].feedbackAgentSettings.bugSettings.severities &&
      productParams.products[0].feedbackAgentSettings.bugSettings.severities
        .length > 0
    ) {
      const msg = { ...errMsg };
      msg.bugSeverityErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.bugCategoryErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.bugSettings.reqCategory &&
      productParams.products[0].feedbackAgentSettings.bugSettings.categories &&
      productParams.products[0].feedbackAgentSettings.bugSettings.categories
        .length > 0
    ) {
      const msg = { ...errMsg };
      msg.bugCategoryErr = null;
      setErrMsg(msg);
    }
  };

  const scroll = (e: any) => {
    e.stopPropagation();
    setScroll("bug");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(2);
  };
  const previewscroll = (e: any) => {
    e.stopPropagation();
    setpreviewScroll("bug");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(1);
  };
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    appLogger.info({
      infoObj: {
        method: "handleAccordianChange",
        component: "add-product",
        fileName: "bugSettings.tsx",
        accordianChangesData: { value, type },
      },
    });
    setGenSettingsAccordianContext(false);
    setBasicDetailAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(value);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(false);
    setWidgAppSettingsAccordianContext(false);
    setWidgIntgSettingsAccordianContext(false);
    setQRSettingsAccordianContext(false);
    if (clickType == "next") {
      if (bugSettingsMandatoryCheck()) {
        if (
          productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].feedbackAgentSettings &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            "FEATURE_REQUEST"
          )
        ) {
          setFreqSettingsAccordianContext(true);
        } else {
          // setEmailSettingsAccordianContext(true);
          setWidgAppSettingsAccordianContext(true);
        }
        setBugSettingsAccordianContext(false);
      }
    }

    if (clickType == "back") {
      setBugSettingsAccordianContext(false);
      if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        setFbSettingsAccordianContext(true);
      } else {
        setGenSettingsAccordianContext(true);
      }
    }
  };
  const renderNextBtnToolTip = () => {
    let tooltip: any = "";
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      )
    ) {
      tooltip = "Go to Feature Request Settings";
    } else {
      tooltip = "Go to Widget Appearence Settings";
    }
    return tooltip;
  };
  const renderPreviuosBtnToolTip = () => {
    let tooltip: any = "";
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      tooltip = "Go to Feedback Settings";
    } else {
      tooltip = "Go to General Settings";
    }
    return tooltip;
  };

  const getRichtext = (e: any) => {
    // setrichtextval(e);

    if (productParams) {
      const temp = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        temp.products[0].feedbackAgentSettings.bugSettings.dialogMsg = e;
        setProductParams(temp);
      }
    }
  };
  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.bugSettings &&
      productParams.products[0].feedbackAgentSettings.bugSettings.dialogMsg
    ) {
      // setrichtextval(
      //   RichTextEditor.createValueFromString(
      //     productParams.products[0].feedbackAgentSettings.bugSettings.dialogMsg,
      //     "html"
      //   )
      // );
    }
  }, []);

  function stripTags(unStripped: any) {
    const parseHTML = new DOMParser().parseFromString(unStripped, "text/html");
    return parseHTML.body.textContent || "";
  }
  const toolbarConfig: any = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
      // "HISTORY_BUTTONS",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "Underline", style: "UNDERLINE" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Normal", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
    ],
  };
  return (
    <Accordion
      expanded={BugSettingsAccordianContext}
      onChange={(e, expanded) => {
        if (expanded) {
          handleAccordianChange(expanded, "basicDetails", "accordian");
        } else {
          handleAccordianChange(expanded, "basicDetails", "accordian");
        }
      }}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            Ticket settings
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="Ticket Settings Help" placement="bottom">
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} onClick={scroll} />
            </Tooltip>
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="Ticket Settings Preview" placement="bottom">
              <PreviewIcon
                sx={{ mx: 1, fontSize: "20px" }}
                onClick={previewscroll}
              />
            </Tooltip>{" "}
          </Grid>
        </Grid>
        {errMsg.bugSettingErr ||
        errMsg.bugCategoryErr ||
        errMsg.bugSeverityErr ? (
          <div className="err-icon-div">
            <ErrorOutlineIcon />
          </div>
        ) : (
          <></>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <IconUpload
            iconStr={
              productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.bugSettings &&
              productParams.products[0].feedbackAgentSettings.bugSettings.icon
                ? productParams.products[0].feedbackAgentSettings.bugSettings
                    .icon
                : ""
            }
            label="Icon for the ticket option"
            iconType={BUGS_OPT}
            productParams={productParams}
            setProductParams={setProductParams}
          />

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>Text for the ticket option </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .title
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.title
                    : ""
                }
                onChange={(event) => handleBugTitleChange(event)}
                id="bug-select"
                label="bug"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Tooltip or additional message with the ticket option
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .tooltip
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.tooltip
                    : ""
                }
                onChange={(event) => handleBugTooltipChange(event)}
                id="bug-tooltipMsg-select"
                label="bug-tooltip Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel className="richtext">
                Message displayed on top of the tickets dialog
              </InputLabel>
              {productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0].platform == "Web" ? (
                // <RichTextEditor
                //   value={richtextval}
                //   onChange={getRichtext}
                //   toolbarClassName="richy"
                //   toolbarConfig={toolbarConfig}
                // />
                <Editor
                  updateData={getRichtext}
                  editorData={
                    productParams &&
                    productParams.products &&
                    productParams.products[0] &&
                    productParams.products[0].feedbackAgentSettings &&
                    productParams.products[0].feedbackAgentSettings
                      .bugSettings &&
                    productParams.products[0].feedbackAgentSettings.bugSettings
                      .dialogMsg
                      ? productParams.products[0].feedbackAgentSettings
                          .bugSettings.dialogMsg
                      : ""
                  }
                />
              ) : (
                <OutlinedInput
                  type="text"
                  value={
                    productParams &&
                    productParams.products &&
                    productParams.products[0] &&
                    productParams.products[0].feedbackAgentSettings &&
                    productParams.products[0].feedbackAgentSettings
                      .bugSettings &&
                    productParams.products[0].feedbackAgentSettings.bugSettings
                      .dialogMsg
                      ? stripTags(
                          productParams.products[0].feedbackAgentSettings
                            .bugSettings.dialogMsg
                        )
                      : ""
                  }
                  onChange={(event) => handleBugDialogMsgChange(event)}
                  id="bugMsg-select"
                  label="bug Msg"
                />
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed on top of category list
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .categoryHeading
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.categoryHeading
                    : ""
                }
                onChange={(event) => handleBugCategoryHeadingChange(event)}
                id="bugCatHeadMsg-select"
                label="bugCatHead Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed on top of severity list
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .severityHeading
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.severityHeading
                    : ""
                }
                onChange={(event) => handleBugSeverityHeadingChange(event)}
                id="bugSevMsg-select"
                label="bugSev Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed on top of standard Feedback text
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .stdFeedbackHeading
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.stdFeedbackHeading
                    : ""
                }
                onChange={(event) => handleBugStdFeedbackHeadingChange(event)}
                id="bugStandardMsg-select"
                label="bugStandard Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed on top of comments text box
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .generalCommentsHeading
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.generalCommentsHeading
                    : ""
                }
                onChange={(event) =>
                  handleBugGeneralCommentsHeadingChange(event)
                }
                id="bugCommentsMsg-select"
                label="bugComments Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed as help to add attachments
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .attachmentHelp
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.attachmentHelp
                    : ""
                }
                onChange={handleBugAttachmentHelpChange}
                id="commentsMsg-select"
                label="comments Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Message to be displayed after the user submits a ticket
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .thanksMsg
                    ? productParams.products[0].feedbackAgentSettings
                        .bugSettings.thanksMsg
                    : ""
                }
                onChange={(event) => handleBugThanksMsgChange(event)}
                id="bugSubmitMsg-select"
                label="bugSubmit Msg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(event) => handleReqComments(event)}
                    checked={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqComments
                        : true
                    }
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqComments
                        : true
                    }
                    color="primary"
                  />
                }
                label="Submitting general comments field is mandatory"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(event) => handleReqDisplayEmail(event)}
                    checked={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqDisplayEmail
                        : true
                    }
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqDisplayEmail
                        : true
                    }
                    color="primary"
                  />
                }
                label="Show email field even when it is set internally"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.showSeverity
                        : true
                    }
                    onChange={handleShowSeverityOption}
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.showSeverity
                        : true
                    }
                    color="primary"
                  />
                }
                label="Show severity options to users"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(event) => handleReqCategory(event)}
                    checked={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqCategory
                        : true
                    }
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .bugSettings
                        ? productParams.products[0].feedbackAgentSettings
                            .bugSettings.reqCategory
                        : true
                    }
                    color="primary"
                  />
                }
                label="Submitting category is mandatory"
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box className="category-wrap">
              <Grid item xs={12}>
                <Typography className="title">
                  Categories:{" "}
                  {productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .reqCategory ? (
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  ) : (
                    <></>
                  )}{" "}
                  {errMsg.bugCategoryErr &&
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .reqCategory ? (
                    <div style={{ display: "inline-block", color: "red" }}>
                      {errMsg.bugCategoryErr}
                    </div>
                  ) : (
                    <></>
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} className="category-list">
                {productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .categories &&
                  productParams.products[0].feedbackAgentSettings.bugSettings.categories.map(
                    (category: ICategory, index: number) => {
                      return (
                        <CategoryList
                          feedbackType={FEEDBACK_TYPE_BUG_REPORT}
                          category={category}
                          catIndex={index}
                          feedbackFlowType={bugFlowType}
                          productParams={productParams}
                          setProductParams={setProductParams}
                          errMsg={errMsg}
                          setErrMsg={setErrMsg}
                        />
                      );
                    }
                  )}
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Button
                  className="add-category-link"
                  fullWidth
                  type="button"
                  variant="text"
                  onClick={() => addBugCategory()}
                  sx={{
                    textTransform: "uppercase",
                  }}
                >
                  <AddIcon />
                  add category
                </Button>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box className="severity-wrap">
              <Grid item xs={12}>
                <Typography className="title">
                  severities :{" "}
                  {productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .showSeverity ? (
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  ) : (
                    <></>
                  )}{" "}
                  {errMsg.bugSeverityErr &&
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings &&
                  productParams.products[0].feedbackAgentSettings.bugSettings
                    .showSeverity ? (
                    <div style={{ display: "inline-block", color: "red" }}>
                      {errMsg.bugSeverityErr}
                    </div>
                  ) : (
                    <></>
                  )}
                </Typography>
              </Grid>
              {productParams &&
                productParams.products &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.bugSettings &&
                productParams.products[0].feedbackAgentSettings.bugSettings
                  .severities &&
                productParams.products[0].feedbackAgentSettings.bugSettings.severities.map(
                  (severity: string, sevIndex: number) => {
                    return (
                      <Grid
                        container
                        spacing={2}
                        sx={{ alignItems: "center", mb: 1 }}
                      >
                        <Grid item sx={{ flexGrow: 1 }}>
                          <FormControl
                            className="custom-select"
                            fullWidth
                            hiddenLabel
                          >
                            {/* <InputLabel>Severity Type </InputLabel> */}
                            <OutlinedInput
                              type="text"
                              value={severity ? severity : ""}
                              onChange={(event) =>
                                handleChangeBugSeverityName(event, sevIndex)
                              }
                              disabled={isJiraSeverity}
                              id={`severity_${sevIndex}`}
                              inputProps={{
                                "aria-label": "severity type",
                              }}
                            />
                          </FormControl>
                        </Grid>
                        {isJiraSeverity ? (
                          <></>
                        ) : (
                          <Grid item>
                            <Tooltip title="Delete Severity" placement="top">
                              <CloseIcon
                                className="cursor-pointer"
                                onClick={() => deleteBugSeverity(sevIndex)}
                              />
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    );
                  }
                )}

              {isJiraSeverity ? (
                <></>
              ) : (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Button
                    className="add-severity-link"
                    type="button"
                    fullWidth
                    variant="text"
                    onClick={() => addBugSeverity()}
                    sx={{
                      textTransform: "uppercase",
                    }}
                  >
                    <AddIcon />
                    add severity
                  </Button>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title={renderPreviuosBtnToolTip()} placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "basicDetails", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>{renderPreviuosBtnToolTip()}</span>
            </Button>
          </Tooltip>
          <Tooltip title={renderNextBtnToolTip()} placement="bottom">
            <Button
              size="small"
              className="nextbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "basicDetails", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>{renderNextBtnToolTip()}</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default BugSettings;
